import { render, staticRenderFns } from "./coApplicant.vue?vue&type=template&id=559dfc10"
import script from "./coApplicant.vue?vue&type=script&lang=js"
export * from "./coApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports